import { useContext, useEffect } from 'react';
import ValidatedSelect from '../../../common/forms/ValidatedSelect';
import { FormContext } from '../../../common/forms/FormElements';

export const Customer = ({ customers, isLoading }) => {
    const { setFieldValue } = useContext(FormContext);

    useEffect(() => {
        if (!isLoading && customers?.length === 1) {
            const [customer] = customers;
            setFieldValue('customerCompanyId', customer.value);
        }
    }, [customers, isLoading, setFieldValue]);

    return (
        <ValidatedSelect
            name="customerCompanyId"
            label="Who is this request on behalf of?"
            required
            hideClear
            error="You must select a company"
            isLoading={isLoading}
            options={customers}
            // Changing the company invalidates any foreman picked for the prior
            // company, so clear it here at the source of the change.
            onChange={() => setFieldValue('foremanId', null)}
        />
    );
};
